import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface SuccessorListItemProps {
  id: string;
  onRemove: (id: string) => void;
  children: React.ReactNode;
}

/**
 * Wraps a successor entity card with an absolutely-positioned remove button.
 */
export function SuccessorListItem({ id, onRemove, children }: SuccessorListItemProps) {
  const { t } = useTranslation();
  return (
    <div className="relative">
      {children}
      <button
        type="button"
        onClick={() => onRemove(id)}
        aria-label={t('common.Remove')}
        className="absolute top-1/2 right-2 -translate-y-1/2 flex h-5 w-5 items-center justify-center rounded-full hover:bg-accent"
      >
        <X className="h-4 w-4 text-muted-foreground" />
      </button>
    </div>
  );
}
